import React, { useState } from 'react'

const PrivacyPolicy = () => {
  const [personalData, setPersonalData] = useState([
    {
      liItem: ` Name and/or name of the representative (in the case of an
        entity)`
    },
    {
      liItem: `Entity in which you work`
    },
    {
      liItem: `The position you hold`
    },
    {
      liItem: `E-mail address`
    },
    {
      liItem: `Proof of identification`
    },
    {
      liItem: `Proof of address/residence`
    },
    {
      liItem: `Telephone/mobile phone number`
    }
  ])
  const [otherInfo, setOtherInfo] = useState([
    {
      liItem: `The IP (Internet Protocol) address`
    },
    {
      liItem: `The type of Internet browser used and its operating system`
    },
    {
      liItem: `The browser language`
    },
    {
      liItem: `The date and time of access(es) and reference URL`
    },
    {
      liItem: `The pages visited on the Farmer’s City platform`
    },
    {
      liItem: `Details on how services are used, including search queries`
    },
    {
      liItem: `Cookies that may uniquely identify your browser or your Account`
    }
  ])
  const [infoWeCollect, setInfoWeCollect] = useState([
    {
      liItem: `The processing of transactions, including payments made through our Website`
    },
    {
      liItem: `The creation, registration and management of your account`
    },
    {
      liItem: `The verification of your identity`
    },
    {
      liItem: `To contact you and answer any questions you may have`
    },
    {
      liItem: `To explore, evaluate and improve the products and/or services supplied and/or provided through the Farmer’s City platform (in particular, to analyze trends in the procurement of agricultural products and/or services, and to analyze our customers database)`
    },
    {
      liItem: `To record your preferences and habits for the products and services marketed on the Farmer’s City platform`
    },
    {
      liItem: `To conduct surveys or statistical analysis to improve our Website and our services`
    },
    {
      liItem: `To fulfill any obligations arising from contracts or agreements entered into with you`
    },
    {
      liItem: `To pursue the legitimate interests of Farmer’s City or third parties, except where such interests are overridden by the interests or fundamental rights and freedoms of the data subject`
    },
    {
      liItem: `To create personalized ads in our Website or in the Farmer’s City platform`
    },
    {
      liItem: `To manage our Website`
    },
    {
      liItem: `To analyze how you visit and how often you access our Website`
    }
  ])
  const [recipients, setRecipients] = useState([
    {
      liItem: `Compliance with a legal obligation to which Farmer’s City is subject`
    },
    {
      liItem: `Defence of vital interests of the data subject or of another individual`
    },
    {
      liItem: `Exercise of public interest functions`
    },
    {
      liItem: `Pursuing the legitimate interests of Farmer’s City or third parties, except where such interests are overridden by the interests or fundamental`
    },
    {
      liItem: `Rights and freedoms of the data subject which require protection`
    }
  ])
  const [rights, setRights] = useState([
    {
      liItem: `Right of access, rectification or erasure`
    },
    {
      liItem: `Right to restriction of processing`
    },
    {
      liItem: `Right to object to the processing`
    },
    {
      liItem: `Right to data portability`
    },
    {
      liItem: `Right to withdraw consent to processing at any time, without compromising the lawfulness of the processing performed based on the previously given consent`
    },
    {
      liItem: `Right to submit a complaint to a supervisory authority`
    }
  ])
  return (
    <div className='py-5'>
      <div className='container px-md-5'>
        <h2 className='mb-0 ff_heebo fw-bold fs_6xl clr_dark_green'>
          Privacy Policy
        </h2>
        <div className='mt-4'>
          <p className='ff_heebo clr_dark_grey_2 fs_md mb-0 mt-3'>
            In order to use the platform named Farmer’s City (“Platform”), it is
            necessary to collect information concerning the entity holding the
            Platform User account (“Account”) and the individual representing
            it, as well as their communication for the purposes expressly set
            out in this Privacy Policy.
          </p>
          <p className='ff_heebo clr_dark_grey_2 fs_md mb-0 mt-3'>
            Farmer’s City privileges information on the Users and transparency
            in the use of its platform, which is why we kindly ask you to
            carefully read the conditions contained in this document, in which
            we inform you not only how we process personal data, its purposes,
            means and conditions for communication thereof, but also of your
            rights as data subject.
          </p>
        </div>
        <div className='mt-4'>
          <h3 className='mb-0 ff_heebo fw-bold fs_4xl clr_dark_green'>
            Information We Collect and Where We Store It
          </h3>
          <div>
            <p className='ff_heebo clr_dark_grey_2 fs_md mb-0 mt-3'>
              For us to provide our service through the Farmer’s City- online
              platform for the purchasing and selling of agricultural products
              and providing agricultural training/upskilling services and
              logistics and agricultural products transportation services - we
              collect, with your consent, the following data:
            </p>
            <div className='ps-4'>
              <h4 className='ff_heebo clr_dark_grey fs_md mb-0 mt-3'>
                Personal data provided by the User (referring to an individual):
              </h4>
              <ul className='ps-3 mt-2 policy-ul'>
                {personalData.map((value, index) => (
                  <li key={index} className='d-flex align-items-center gap-2'>
                    <div className='policy-ul-li-dots'></div>
                    <p className='mb-0 ff_heebo clr_dark_grey_2 fs_sm'>
                      {value.liItem}
                    </p>
                  </li>
                ))}
              </ul>
            </div>
            <div className='ps-4'>
              <h4 className='ff_heebo clr_dark_grey fs_md mb-0 mt-3'>
                Other information that we may collect:
              </h4>
              <ul className='ps-3 mt-2 policy-ul'>
                {otherInfo.map((value, index) => (
                  <li key={index} className='d-flex align-items-center gap-2'>
                    <div className='policy-ul-li-dots'></div>
                    <p className='mb-0 ff_heebo clr_dark_grey_2 fs_sm'>
                      {value.liItem}
                    </p>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        <div className='mt-4'>
          <h3 className='mb-0 ff_heebo fw-bold fs_4xl clr_dark_green'>
            Use Given to the Information We Collect
          </h3>
          <div>
            <p className='ff_heebo clr_dark_grey_2 fs_md mb-0 mt-3'>
              We use the information we collect to provide intermediation
              services in the purchasing and selling of agricultural products
              and/or the supply and delivery of logistics and agricultural
              products and/or agricultural training or upskilling services. We
              may also use the information you have provided for the following
              purposes:
            </p>
            <ul className='ps-3 mt-2 policy-ul'>
              {infoWeCollect.map((value, index) => (
                <li key={index} className='d-flex align-items-start gap-2'>
                  <div className='policy-ul-li-dots mt-2'></div>
                  <p className='mb-0 ff_heebo clr_dark_grey_2 fs_sm'>
                    {value.liItem}
                  </p>
                </li>
              ))}
            </ul>
            <p className='ff_heebo clr_dark_grey_2 fs_md mb-0 mt-3'>
              Additionally, we may use the email address provided when creating
              your account to send you information about our services, for
              example by informing you of future changes or improvements. We
              further use the information we collect within the provision of our
              services to maintain, protect and improve our services, as well as
              to ensure the exercise of the rights of the Users. We may also use
              anonymous data to monitor the use of our Webpage.
            </p>
          </div>
        </div>
        <div className='mt-4'>
          <h3 className='mb-0 ff_heebo fw-bold fs_4xl clr_dark_green'>
            Communication of the Data and Its Recipients
          </h3>
          <div>
            <p className='ff_heebo clr_dark_grey_2 fs_md mb-0 mt-3'>
              In order for you to enjoy the services offered by the Farmer’s
              City platform, it is essential to communicate the Account User
              data to third parties; and Farmer’s City may also communicate your
              data namely to comply with any legal or contractual obligation.
              When this happens, Farmer’s City shall take appropriate measures
              to ensure that any entities having access to the data offer the
              highest guarantees at this level, adopting the necessary technical
              and organizational measures to protect personal data against
              accidental or unlawful destruction, accidental loss, alteration,
              disclosure or unauthorized access and against any other form of
              illicit processing.
            </p>
            <p className='ff_heebo clr_dark_grey_2 fs_md mb-0 mt-3'>
              The Account public data (company name, tax identification number,
              registered office, User's email address) shall be communicated to
              Users who are parties to the purchase and sale or provision of
              services agreements to be signed through the Platform. Shall also
              be communicated to the payment service provider, in order to
              ensure the execution of the financial operations resulting from
              the use of the platform, the elements contained in the User
              account and its payment data, as well as information concerning
              the purchase and sale transactions made by the User. For more
              information, please refer to the chapter on collection and
              processing of personal data, of the terms and conditions of use of
              the partner payment platform available in farmerscity.in. We may
              furthermore provide the personal data collected to our partners,
              other companies and reliable people for processing purposes, based
              on our instructions and in compliance with our Privacy Policy,
              subject to the use of security and confidentiality measures.
            </p>
            <p className='ff_heebo clr_dark_grey_2 fs_md mb-0 mt-3'>
              Additionally, your personal data may be communicated to third
              parties provided that it is necessary for:
            </p>
            <ul className='ps-3 mt-2 policy-ul'>
              {recipients.map((value, index) => (
                <li key={index} className='d-flex align-items-start gap-2'>
                  <div className='policy-ul-li-dots mt-2'></div>
                  <p className='mb-0 ff_heebo clr_dark_grey_2 fs_sm'>
                    {value.liItem}
                  </p>
                </li>
              ))}
            </ul>
            <p className='ff_heebo clr_dark_grey_2 fs_md mb-0 mt-3'>
              Finally, we may share anonymized information, that is information
              that does not contain personally identifiable information,
              publicly and with our partners, in particular, information to show
              trends in relation to the general use of our services.
            </p>
          </div>
        </div>
        <div className='mt-4'>
          <h3 className='mb-0 ff_heebo fw-bold fs_4xl clr_dark_green'>
            International Data Transfers
          </h3>
          <div>
            <p className='ff_heebo clr_dark_grey_2 fs_md mb-0 mt-3'>
              The use of the Platform may involve the transfer of your data
              outside of India. In such a case, Farmer’s City shall strictly
              comply with the applicable legal provisions in determining the
              adequacy of the level of protection of personal data of the
              recipient country of the transfer, and as regards any requirements
              applicable to the transfer.
            </p>
          </div>
        </div>
        <div className='mt-4'>
          <h3 className='mb-0 ff_heebo fw-bold fs_4xl clr_dark_green'>
            Retention Period for Data
          </h3>
          <div>
            <p className='ff_heebo clr_dark_grey_2 fs_md mb-0 mt-3'>
              Without prejudice to the privacy policies of third parties with
              respect to personal data processed by them, and any legal
              provision to the contrary, your personal data will be kept for the
              period of time necessary for the execution of our services through
              the use of the Farmer’s City platform, or until you exercise your
              right to object, withdraw your consent for the processing or
              request the deletion of the data.
            </p>
          </div>
        </div>
        <div className='mt-4'>
          <h3 className='mb-0 ff_heebo fw-bold fs_4xl clr_dark_green'>
            Use Given to the Information We Collect
          </h3>
          <div>
            <p className='ff_heebo clr_dark_grey_2 fs_md mb-0 mt-3'>
              As holder of the personal data we collect, you have the following
              rights:
            </p>
            <ul className='ps-3 mt-2 policy-ul'>
              {rights.map((value, index) => (
                <li key={index} className='d-flex align-items-start gap-2'>
                  <div className='policy-ul-li-dots mt-2'></div>
                  <p className='mb-0 ff_heebo clr_dark_grey_2 fs_sm'>
                    {value.liItem}
                  </p>
                </li>
              ))}
            </ul>
            <p className='ff_heebo clr_dark_grey_2 fs_md mb-0 mt-3'>
              These rights may be exercised directly by accessing the User
              account, in the Farmers City platform, or by sending an email to
              info@farmerscity.in, making your request.
            </p>
          </div>
        </div>
        <div className='mt-4'>
          <h3 className='mb-0 ff_heebo fw-bold fs_4xl clr_dark_green'>
            Information Security Measures
          </h3>
          <div>
            <p className='ff_heebo clr_dark_grey_2 fs_md mb-0 mt-3'>
              Farmer’s City platform is committed to ensuring the protection of
              the security of personal data that is made available to it and has
              adopted and implemented strict organizational and technical
              security measures, in particular, protecting the channel between
              the browser and the server through a HTTPS certificate in order to
              protect personal data against its unauthorized diffusion, loss,
              misuse, alteration, processing or access, and against any other
              forms of illicit processing.
            </p>
            <p className='ff_heebo clr_dark_grey_2 fs_md mb-0 mt-3'>
              Notwithstanding the security measures adopted by Farmer’s City,
              you should take additional security measures, such as ensuring
              that you use an up-to-date computer and browser as regards
              properly configured security patches, with active firewall,
              antivirus and anti-spyware, as well as verifying the authenticity
              of the web pages you visit on the Internet and avoiding pages
              whose reputation you do not trust.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PrivacyPolicy
